export function captureVideoFrame(video) {
  return new Promise((resolve, reject) => {
    try {
      if (!video || video.readyState < 2 || !video.videoWidth || !video.videoHeight) {
        throw new Error('La vidéo n’est pas prête. Attendez le chargement de l’image.');
      }
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      canvas.toBlob((blob) => {
        if (blob) resolve(new File([blob], 'poster.png', { type: 'image/png' }));
        else reject(new Error('Cette image de la vidéo ne peut pas être extraite.'));
      }, 'image/png');
    } catch (error) {
      reject(new Error('Impossible de capturer cette vidéo. Vérifiez son chargement et l’autorisation du serveur à lire ses images.'));
    }
  });
}

/**
 * Première frame d'une vidéo, extraite dans le navigateur.
 *
 * C'est le seul moyen d'obtenir une vignette : ffmpeg n'est pas disponible côté
 * serveur, `ActiveStorage#preview` ne sait donc pas prévisualiser une vidéo.
 * Le poster est ensuite envoyé en `poster_signed_id` à côté du fichier.
 *
 * Rend `null` — et jamais une erreur — quand la frame ne peut pas être lue :
 * une vidéo sans vignette reste une vidéo valide.
 */
const extractVideoPoster = (file) =>
  new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const video = document.createElement('video');
    let finished = false;
    const finish = (result) => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      video.onloadeddata = null;
      video.onerror = null;
      video.removeAttribute('src');
      URL.revokeObjectURL(objectUrl);
      resolve(result);
    };
    const timeout = setTimeout(() => finish(null), 15000);
    video.preload = 'auto';
    video.muted = true;
    video.onloadeddata = () => captureVideoFrame(video).then(finish, () => finish(null));
    video.onerror = () => finish(null);
    video.src = objectUrl;
  });

export default extractVideoPoster;
